import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import SwitchBtn from "components/Custom/SwitchBtn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import ChkBox from "components/Custom/ChkBox";

import { NOTIFY, DEFAULTS, FORMATS } from "common/config";
import { COLORS } from "common/colors";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import { DateFunctions } from "common/datefunctions";
import { REEFER } from "common/config";

import { ApiMasters } from "apihandlers//masters/masters";
import { ApiIndents } from "apihandlers//indent";
import { ApiGeography } from "apihandlers//geography";

import "../Placement/styles/users.css";

const ApiMastersHandler = new ApiMasters();
const ApiIndentHandler = new ApiIndents();
const ApiGeographyHandler = new ApiGeography();

const Placement = (props: any) => {
  const { setDashMenu } = props;

  const tempIdRef: any = useRef();
  const placementRef: any = useRef();
  const loadingPointIdRef: any = useRef();
  const unloadingPointIdRef: any = useRef();
  const vehicleIdRef: any = useRef();
  const customerIdRef: any = useRef();
  const brokerIdRef: any = useRef();
  const driversRef: any = useRef();
  const drivers2Ref: any = useRef();

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [loadingPoints, setLoadingPoints] = useState<any>(null);
  const [unLoadingPoints, setUnLoadingPoints] = useState<any>(null);
  const [vehicles, setVehicles] = useState<any>(null);
  const [customers, setCustomers] = useState<any>(null);
  const [tempratures, setTempratures] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [driverNames, setDriverNames] = useState<any>([]);
  const [driver2Names, setDriver2Names] = useState<any>([]);
  const [selectedLoadPoints, setSelectedLoadPoints] = useState<any>();
  const [getAllPoints, setGetAllPoints] = useState<boolean>(false);
  const [selectedUnLoadPoints, setSelectedUnLoadPoints] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any>({});

  useEffect(() => {
    if (loading) {
      getVehicles();
    }
  }, [loading]);

  const getVehicles = () => {
    const args = {
      activeStatus: "true",
      shortMode: true,
    };
    ApiMastersHandler.getVehicles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.vehicleNumber,
          };
        });
        setVehicles(list);
        getAreas();
      }
    });
  };

  const getAreas = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiGeographyHandler.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        // setLoadingPoints(list);
        setUnLoadingPoints(list);
        getCustomers();
      }
    });
  };

  const getCustomers = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiMastersHandler.getTransporters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.organizationName,
          };
        });
        setCustomers(list);
        getTempRanges();
      }
    });
  };

  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      fromDate: DateFunctions.getDate("thisyear", "from", FORMATS.SQL_DATE),
      toDate: DateFunctions.getDate("thisyear", "to", FORMATS.SQL_DATE),
      noVehicle: "true"
    };
    ApiIndentHandler.getTrips(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
          list[i]["totCrates"] = Number(list[i]["totCrates"]);
          const placement = list.find((r: any) => r.id === list[i].id);
          // console.log("placement: ", i, placement, list[i], list);
          list[i].vehicleId = placement ? placement.vehicleId : vehicles.id;
          list[i].placingDate = placement ? placement.placingDate : "";
        }
        setRows(list);
        setLoading(false);
        console.log("Rows", list);
      }
    });
  };

  const getTripLoadUnloads = (indentId) => {
    const args = { indentId, activeStatus: "true", web: true };
    ApiIndentHandler.getLoadUnloadPoints(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        setSelectedLoadPoints(response.loadPoints);
        setSelectedUnLoadPoints(response.unloadPoints);
      }
    });
  };

  const getTempRanges = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiMastersHandler.getTempRanges(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.tempName,
          };
        });
        setTempratures(list);
        getDrivers();
      }
    });
  };

  const getDrivers = () => {
    const args = {
      activeStatus: true,
      shortMode: true,
    };
    ApiMastersHandler.getDrivers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setDriverNames(list);
        setDriver2Names(list);
        getLoadingPoints();
      }
    });
  };

  const getLoadingPoints = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
      loadingOnlyStatus: "true",
    };
    ApiGeographyHandler.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setLoadingPoints(list);
        //setUnLoadingPoints(list);
        getRows();
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    setSelectedLoadPoints(null);
    setSelectedUnLoadPoints(null);
    getTripLoadUnloads(row.id);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      frozen: true,
    },
    {
      key: "indentNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INDENT_NO,
      width: "10%",
      frozen: true,
    },
    {
      key: "vehicleNo",
      name: LABELS.VEHICLE_NO,
      editable: true,
      sortable: true,
      searchable: true,
      type: "dropdown2",
      list: vehicles,
      width: "10%",
    },
    {
      key: "ldDate",
      type: "datetime",
      editable: true,
      sortable: true,
      searchable: true,
      name: LABELS.LOADING_DATE,
      width: "15%",
    },
    {
      key: "indReceiptDate",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INDENT_DATE,
      width: "12%",
      frozen: true,
    },
    {
      key: "fromLoc",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "From",
      width: "10%",
    },
    {
      key: "toLoc",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: "To",
      width: "10%",
    },
    {
      key: "totCrates",
      type: "number",
      editable: true,
      sortable: true,
      searchable: true,
      name: LABELS.ORDERED_QTY,
      width: "5%",
    },
    {
      key: "crateCapacity",
      name: LABELS.CRATE_CAPACITY,
      type: "number",
      width: "7%",
      sortable: true,
      searchable: true,
    },
    {
      key: "driverName",
      name: LABELS.DRIVERS_NAME,
      type: "text",
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      searchable: true,
    },
    {
      key: "driverBalance",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DRIVER_BALANCE,
      width: "10%",
    },
    {
      key: "weight",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.NET_WT,
      width: "5%",
    },
    {
      key: "maxPassingTon",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PASSING_TON,
      width: "5%",
    },
    {
      key: "status",
      type: "dropdown",
      filters: [
        {
          id: "created",
          name: "CREATED",
        },
        {
          id: "assigned",
          name: "ASSIGNED",
        },
        {
          id: "completed",
          name: "COMPLETED",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.STATUS,
      width: "5%",
    },
    {
      key: "indentGroup",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.GROUP,
      width: "10%",
    },
    {
      key: "referenceNo",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.REFERENCE,
      width: "5%",
    },
    {
      key: "activeStatusText",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "5%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageRecord = () => {
    const placementDate = (
      document.getElementById("placementDate") as HTMLInputElement
    ).value.trim();
    const vehicleId = vehicleIdRef.current.selectedValue.id;

    // Validations
    // if (!vehicleId) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!placementDate) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    let errors = [];
    if (!vehicleId) {
      errors.push({
        id: "vehicleId",
        msg:
          "<span class='bold'>" +
          LABELS.VEHICLE_NO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (placementDate == "") {
      errors.push({
        id: "placementDate",
        msg:
          "<span class='bold'>" +
          LABELS.PLACEMENT_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      vehicleId: vehicleId,
      placementDate: placementDate,
    };

    console.log("manage", args);
    setIsSubmit(true);
    ApiIndentHandler.manageIndentPlacement(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onManagePlacement = async () => {
    try {
      let gridRows = placementRef.getRowData();
      const args = {
        placements: gridRows.map((p) => {
          return {
            id: p.id,
            vehicleNoId: p.vehicleNoId,
            ldDate: p.ldDate,
          };
        }),
      };
      console.log("manageIndentPlacement", gridRows);
      // return;
      const res = await ApiIndentHandler.manageIndentPlacement(args);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
      }
      setLoading(false);
    } catch (error) {
      console.error("manageIndentPlacement: ", error);
    }
  };

  // const onSave = () => {
  //   const args = {
  //     placements: [
  //       {
  //         indexId: 688,
  //         vehicleId: 10154,
  //         driverId: 168,
  //         driver2Id: 168,
  //         vehicleAvailableOn: "2023-08-24 12:50:15",
  //       },
  //     ],
  //   };
  //   console.log("manage", args);
    // setIsSubmit(true);
    // ApiIndentHandler.manageIndentPlacement(args).then((res) => {
    //   setIsSubmit(false);
    //   if (res.status === 200) {
    //     COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
    //     setSelectedRow({});
    //     setManageDialog(false);
    //     reloadGrid();
    //   } else {
    //     COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    //   }
    // });
  // };

  let frightModes = [
    {
      id: "freightTypeToPay",
      value: "TOPAY",
      label: LABELS.TO_PAY,
      checked: selectedRow.id ? selectedRow.freightType === "TOPAY" : false,
      disabled: false,
    },
    {
      id: "freightTypePaid",
      value: LABELS.PAID,
      label: LABELS.PAID,
      checked: selectedRow.id ? selectedRow.freightType === "PAID" : false,
      disabled: false,
    },
    {
      id: "freightTypeTbb",
      value: LABELS.TBB,
      label: LABELS.TBB,
      checked: selectedRow.id ? selectedRow.freightType === "TBB" : false,
      disabled: false,
    },
  ];
  frightModes = frightModes.filter((f) => {
    return f.value === selectedRow.freightType;
  });

  let indModes = [
    {
      id: "indModeMobile",
      value: "Mobile",
      label: LABELS.MOBILE,
      checked: selectedRow.id ? selectedRow.indMode === "Mobile" : false,
      disabled: false,
    },
    {
      id: "indModePhone",
      value: "Phone",
      label: LABELS.IND_PHONE,
      checked: selectedRow.id ? selectedRow.indMode === "Phone" : false,
      disabled: false,
    },
    {
      id: "indModeEmail",
      value: "Email",
      label: LABELS.EMAIL,
      checked: selectedRow.id ? selectedRow.indMode === "Email" : false,
      disabled: false,
    },
    {
      id: "indModeWhatsapp",
      value: "Whatsapp",
      label: LABELS.WHATSAPP,
      checked: selectedRow.id ? selectedRow.indMode === "Whatsapp" : false,
      disabled: false,
    },
    {
      id: "indModeMessage",
      value: "Message",
      label: LABELS.MESSAGE,
      checked: selectedRow.id ? selectedRow.indMode === "Message" : false,
      disabled: false,
    },
  ];
  indModes = indModes.filter((f) => {
    return f.value === selectedRow.indMode;
  });

  let trips = [
    {
      id: "ldTypeRevenue",
      value: "RevenueTrip",
      label: LABELS.REVENUE_TRIP,
      checked: selectedRow.id ? selectedRow.ldType === "RevenueTrip" : false,
      disabled: false,
    },
    {
      id: "ldTypeEmpty",
      value: "EmptyTrip",
      label: LABELS.EMPTY_TRIP,
      checked: selectedRow.id ? selectedRow.ldType === "EmptyTrip" : false,
      disabled: false,
    },
  ];
  trips = trips.filter((f) => {
    return f.value === selectedRow.ldType;
  });

  let Status = [
    {
      id: "activeStatusYes",
      value: "true",
      label: LABELS.ACTIVE,
      checked: selectedRow.id ? selectedRow.activeStatus === true : true,
      disabled: false,
    },
    {
      id: "activeStatusNo",
      value: "false",
      label: LABELS.INACTIVE,
      checked: selectedRow.id ? selectedRow.activeStatus === false : false,
      disabled: false,
    },
  ];
  Status = Status.filter((f) => {
    return f.value === selectedRow.activeStatus;
  });

  const onCancel = () => {
    setGetAllPoints(false);
    setManageDialog(false);
    setMandatoryResults([]);
  };

  console.log("placements:", vehicles, driverNames);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTIONS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.PLACEMENT}</li>
        </ul>
        <h4>{TITLES.PLACEMENT}</h4>
        <p className="SubTitles">{SUB_TITLES.PLACEMENT}</p>
      </div>

      {rows ? (
        <>
          <div className="grid excelGridWrapper">
            <ExcelGrid
              id={LABELS.PLACEMENT}
              childRef={placementRef}
              height={window.innerHeight * 0.7}
              cols={COLUMNS}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.PLACEMENT}
              onReload={reloadGrid}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "right",
              width: "96.5%",
            }}
          >
            <div
              style={{
                width: "35%",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={onManagePlacement}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="grid excelGridWrapper">
          <div className="flexRowCenter">
            <Loader />
          </div>
        </div>
      )}

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.PLACEMENT + " : " + selectedRow.indentNo
              : "Add New " + LABELS.PLACEMENT
          }
          open={true}
          size={"lg"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          {selectedLoadPoints && selectedUnLoadPoints ? (
            <>
              <div className="flexColumn">
                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.FREIGHT_AND_INDENT_DETAILS}
                  </legend>

                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"indContact"}
                        label={LABELS.INDENT_CONTACT}
                        defaultValue={selectedRow.indContact}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"indReceiptDate"}
                        label={LABELS.INDENT_DATE}
                        type={"datetime-local"}
                        defaultValue={
                          selectedRow.indReceiptDate
                            ? DateFunctions.getFormatedDate(
                                selectedRow.indReceiptDate,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                        disabled={true}
                      />
                    </div>{" "}
                    <div className="formGroup width30 ">
                      <TxtRow
                        id={"freight"}
                        label={LABELS.FRIGHT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.freight).toString()
                            : ""
                        }
                        disabled={true}
                      />
                    </div>
                  </div>

                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"referenceNo"}
                        label={LABELS.BILLING_LOCATION}
                        defaultValue={selectedRow.referenceNo}
                        disabled={true}
                      />
                    </div>{" "}
                    <div className="formGroup width30">
                      <label>{LABELS.FREIGHT_MODE}</label>
                      <RadioBtn
                        list={frightModes}
                        row={true}
                        name={"freightType"}
                        disabled={true}
                      />
                    </div>
                    {REEFER ? (
                      <div className="formGroup width30">
                        <label>{LABELS.TEMP_RANGE}</label>
                        <AutoComplete
                          list={tempratures}
                          childRef={tempIdRef}
                          defaultValue={
                            selectedRow.temprangeId
                              ? {
                                  id: selectedRow.temprangeId,
                                  label: selectedRow.tempRangeName,
                                }
                              : null
                          }
                          disabled={true}
                        />
                      </div>
                    ) : (
                      <div className="formGroup width30"></div>
                    )}
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <label>{LABELS.TRIP_CAT}</label>
                      <RadioBtn
                        list={trips}
                        row={true}
                        name={"ldType"}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.INDENT_MODE}</label>
                      <RadioBtn
                        list={indModes}
                        row={true}
                        name={"indMode"}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <ChkBox
                        id="roundTrip"
                        text={LABELS.ROUND_TRIP}
                        style={{ fontWeight: "600" }}
                        disabled={true}
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.INITIAL_TRIP_DATA}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width30 red">
                      <label>
                        {LABELS.VEHICLE_NO} {<span>{" *"}</span>}
                      </label>
                      <AutoComplete
                        list={vehicles}
                        childRef={vehicleIdRef}
                        defaultValue={
                          selectedRow.vehicleNo
                            ? {
                                id: selectedRow.vehicleId,
                                label: selectedRow.vehicleNo,
                              }
                            : null
                        }
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.DRIVER_NAME}</label>
                      <AutoComplete
                        list={driverNames}
                        childRef={driversRef}
                        defaultValue={
                          selectedRow.driverId
                            ? {
                                id: selectedRow.driverId,
                                label: selectedRow.driverName,
                              }
                            : null
                        }
                        onChange={(e, v) => {}}
                        //disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.DRIVER_2_NAME}</label>
                      <AutoComplete
                        list={driver2Names}
                        childRef={drivers2Ref}
                        defaultValue={
                          selectedRow.driver2Id
                            ? {
                                id: selectedRow.driver2Id,
                                label: selectedRow.driver2Name,
                              }
                            : null
                        }
                        onChange={(e, v) => {}}
                        disabled={isSubmit}
                      />
                    </div>
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width30 ">
                      <label>{LABELS.CUSTOMER}</label>
                      <AutoComplete
                        list={customers}
                        childRef={customerIdRef}
                        defaultValue={
                          selectedRow.id
                            ? {
                                id: selectedRow.transporterId,
                                label: selectedRow.transporterName,
                              }
                            : null
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.BROKER}</label>
                      <AutoComplete
                        list={customers}
                        childRef={brokerIdRef}
                        defaultValue={
                          selectedRow.brokerId
                            ? {
                                id: selectedRow.brokerId,
                                label: selectedRow.brokerName,
                              }
                            : null
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"ldDate"}
                        label={LABELS.LOADING_DATE}
                        type={"datetime-local"}
                        defaultValue={
                          selectedRow.ldDate
                            ? DateFunctions.getFormatedDate(
                                selectedRow.ldDate,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"odometerOpen"}
                        label={LABELS.OPENING_KM}
                        type={"number"}
                        defaultValue={selectedRow.odometerOpen}
                        disabled={true}
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.ROUTE_DETAILS}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width45">
                      <div className="flexRowJustify ">
                        <label
                          style={{ marginTop: "0.5rem", fontWeight: "500" }}
                        >
                          {LABELS.LOADING_PT}
                        </label>
                        <Btn
                          text={LABELS.SHOW_ALL_POINTS}
                          bgColor={"#e9e9e9"}
                          color={"#3f3f3f"}
                          onClick={(prevGetAllPoints) => {
                            setGetAllPoints(
                              (prevGetAllPoints) => !prevGetAllPoints
                            );
                          }}
                        />
                      </div>
                      {selectedLoadPoints && (
                        <AutoComplete
                          list={getAllPoints ? unLoadingPoints : loadingPoints}
                          childRef={loadingPointIdRef}
                          multiple={true}
                          defaultValue={selectedRow ? selectedLoadPoints : []}
                          disabled={true}
                        />
                      )}
                    </div>
                    <div
                      className="formGroup width45 "
                      style={{ paddingTop: "0.4rem" }}
                    >
                      <label>{LABELS.UNLOADING_PT}</label>
                      {selectedUnLoadPoints && (
                        <AutoComplete
                          list={unLoadingPoints}
                          childRef={unloadingPointIdRef}
                          multiple={true}
                          defaultValue={selectedRow ? selectedUnLoadPoints : []}
                          disabled={true}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width45">
                      <TxtRow
                        id={"product"}
                        label={LABELS.PRODUCT}
                        defaultValue={selectedRow.product}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width45">
                      <TxtRow
                        id={"totCrates"}
                        label={LABELS.ORDERED_QTY}
                        type={"number"}
                        defaultValue={selectedRow.totCrates}
                        disabled={true}
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.LOAD_WEIGHTS}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"grossWt"}
                        label={LABELS.GROSS_WT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.grossWt).toString()
                            : ""
                        }
                        disabled={true}
                      />
                    </div>

                    <div className="formGroup width30">
                      <TxtRow
                        id={"tareWt"}
                        label={LABELS.TARE_WT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.tareWt).toString()
                            : ""
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"weight"}
                        label={LABELS.NET_WT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.weight).toString()
                            : ""
                        }
                        disabled={true}
                      />
                    </div>
                  </div>

                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"billDate"}
                        label={LABELS.BILL_DATE}
                        type={"datetime-local"}
                        defaultValue={
                          selectedRow.billDate
                            ? DateFunctions.getFormatedDate(
                                selectedRow.billDate,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"billNumber"}
                        label={LABELS.BILL_NO}
                        type={"number"}
                        defaultValue={selectedRow.billNumber}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30"></div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.DELIVERY_DETAILS}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"deliveredCrates"}
                        label={LABELS.DELIVERED_QTY}
                        type={"number"}
                        defaultValue={selectedRow.deliveredCrates}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"odometerClose"}
                        label={LABELS.CLOSING_KM}
                        type={"number"}
                        defaultValue={selectedRow.odometerClose}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30"></div>
                  </div>
                </fieldset>

                <div
                  className="flexRowJustify"
                  style={{ alignItems: "center" }}
                >
                  <div className="formGroup width30 ">
                    <label>{LABELS.ACTIVE_STATUS}</label>
                    <RadioBtn
                      list={[
                        {
                          id: "activeYes",
                          value: "true",
                          label: LABELS.ACTIVE,
                          checked: selectedRow.id
                            ? selectedRow.activeStatus === true
                            : true,
                          disabled: false,
                        },
                        {
                          id: "activeNo",
                          value: "false",
                          label: LABELS.INACTIVE,
                          checked: selectedRow.id
                            ? selectedRow.activeStatus === false
                            : false,
                          disabled: false,
                        },
                      ]}
                      row={true}
                      name={"activeStatus"}
                      disabled={true}
                    />
                  </div>
                  <div className="formGroup width30 red">
                    <TxtRow
                      id={"placementDate"}
                      label={LABELS.PLACEMENT_DATE}
                      type={"datetime-local"}
                      defaultValue={
                        selectedRow.placingDate
                          ? DateFunctions.getFormatedDate(
                              selectedRow.placingDate,
                              FORMATS.SQL_DATE,
                              FORMATS.SQL_DATE
                            )
                          : DateFunctions.getDate(
                              "now",
                              "from",
                              FORMATS.SQL_DATE
                            )
                      }
                      required={true}
                    />
                  </div>
                  <div className="formGroup width30"></div>
                </div>
              </div>

              {/* mandatoryResults */}
              {mandatoryResults.length > 0 && (
                <div className="mandatoryBox">
                  <ul>
                    {mandatoryResults.map((m) => {
                      return (
                        <li>
                          <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
              <div className="formGroup submitBtnWrapper">
                <div
                  className=" flexbtnjustify"
                  // style={{ paddingTop: "4rem" }}
                >
                  {/* <Btn
                    text={LABELS.CANCEL}
                    bgColor={COLORS.RELOAD_EXPORT}
                    color={COLORS.RELOAD_EXPORT_TEXT}
                    // loading={isSubmit}
                    onClick={onCancel}
                  /> */}
                  {/* <Btn
                    text={LABELS.SAVE}
                    loading={isSubmit}
                    onClick={manageRecord}
                    bgColor={COLORS.SAVE_GREEN}
                  /> */}
                </div>
              </div>
            </>
          ) : (
            <div className="flexCenter" style={{ height: 500 }}>
              <Loader />
            </div>
          )}
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Placement);
